export const CARD_MAX_WIDTH = 1784;
export const CARD_LABEL_MIN_WIDTH = 300;
export const CARD_CHART_MIN_WIDTH = 420;
export const CARD_TABLE_MIN_WIDTH = 856;
export const CHART_CONTAINER_HEIGHT = 372;
